import './header.scss'

const selectors = {
  hero: '[data-hero]',
  header: '[data-header]',
  headerLanguages: '[data-header-languages]',
  headerMenu: '[data-header-menu]',
  headerMenuTrigger: '[data-header-menu-trigger] > *',
}

const initHeader = () => {
  const hero = document.querySelector(selectors.hero)
  const header = document.querySelector(selectors.header)
  const headerMenu = document.querySelector(selectors.headerMenu)
  const headerMenuTriggers = document.querySelectorAll(selectors.headerMenuTrigger)
  const headerLanguages = document.querySelector(selectors.headerLanguages)

  const setActiveClass = (element) => {
    element.classList.toggle('active')

    if (hero) {
      element.classList.toggle('white')
    }
  }

  const preventBodyScroll = () => {
    const isFixed = document.body.hasAttribute('data-fixed')

    document.body[isFixed ? 'removeAttribute' : 'setAttribute']('data-fixed', '')
  }

  const setHeaderClass = () => {
    if (!hero) {
      header.classList.add('white')
    }

    if (window.scrollY === 0 && header.classList.contains('active')) {
      setActiveClass(header)
    }

    if (window.scrollY > 0 && !header.classList.contains('active')) {
      setActiveClass(header)
    }
  }

  window.addEventListener('scroll', setHeaderClass)

  headerLanguages?.firstElementChild.addEventListener('click', () => {
    headerLanguages.classList.toggle('active')
  })

  headerMenuTriggers?.forEach((trigger) =>
    trigger.addEventListener('click', () => {
      preventBodyScroll()
      setActiveClass(headerMenu)
    })
  )

  setHeaderClass()
}

document.addEventListener('DOMContentLoaded', async function () {
  initHeader()
})
